const NAME = "SCHEDULES_PROGRAMMING";

export default NAME;
